import { Controller } from "@hotwired/stimulus"

// A shelf bay that scrolls sideways through its whole list (shared/_shelf_bay).
// Its boxes come a page at a time: the first page with the shelf, and the next
// as soon as the one before it is scrolled into, so the next page is always
// there before it's needed. Each page is asked for once (by its offset), one
// at a time. The arrows scroll a bayful at a time.
export default class extends Controller {
  static targets = ["reel", "sentinel", "prev", "next"]
  static values = { url: String, total: Number, loaded: Number, page: Number }

  connect() {
    this.requested = new Set()
    this.update()
  }

  // How many boxes should be in by now: the first page, and once it's
  // scrolled, the page after whichever one is in view.
  wanted() {
    const reel = this.reelTarget
    if (reel.scrollLeft <= 0) return this.pageValue
    const right = reel.getBoundingClientRect().right
    const boxes = [ ...reel.querySelectorAll(".sh-bx") ]
    const lastSeen = boxes.findLastIndex((box) => box.getBoundingClientRect().left < right)
    const page = Math.floor(Math.max(lastSeen, 0) / this.pageValue)
    return (page + 2) * this.pageValue
  }

  async fill() {
    if (this.loading) return
    this.loading = true
    try {
      while (this.loadedValue < Math.min(this.wanted(), this.totalValue)) {
        const offset = this.loadedValue
        if (this.requested.has(offset)) break
        this.requested.add(offset)
        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("offset", offset)
        const response = await fetch(url, { headers: { Accept: "text/html" } })
        if (!response.ok) break
        const before = this.reelTarget.querySelectorAll(".sh-bx").length
        this.sentinelTarget.insertAdjacentHTML("beforebegin", await response.text())
        const added = this.reelTarget.querySelectorAll(".sh-bx").length - before
        this.loadedValue += added
        if (added === 0) this.totalValue = this.loadedValue
      }
      if (this.loadedValue >= this.totalValue && this.hasSentinelTarget) this.sentinelTarget.remove()
    } finally {
      this.loading = false
    }
    this.arrows()
  }

  prev() { this.scrollBy(-1) }
  next() { this.scrollBy(1) }

  scrollBy(direction) {
    this.reelTarget.scrollBy({ left: direction * this.reelTarget.clientWidth * 0.9, behavior: "smooth" })
  }

  update() {
    this.arrows()
    if (this.hasSentinelTarget) this.fill()
  }

  arrows() {
    const reel = this.reelTarget
    const atStart = reel.scrollLeft <= 2
    const atEnd = reel.scrollLeft + reel.clientWidth >= reel.scrollWidth - 2 && this.loadedValue >= this.totalValue
    if (this.hasPrevTarget) this.prevTarget.hidden = atStart
    if (this.hasNextTarget) this.nextTarget.hidden = atEnd
  }
}
